import React from 'react';
import Lottie from 'lottie-react';

import blackLoader from 'src/assets/lottie/black-loader.json';

import styles from './index.module.scss';

interface LoaderProps {
  noBackground: boolean;
};

const Loader: React.FunctionComponent<LoaderProps> = ({ noBackground }) => {
  return (
    <section className={noBackground ? styles.loading : styles.loading_with_bg}>
      <Lottie
        className={styles.loaderAnimation}
        animationData={blackLoader}
        loop={true}
      />
    </section>
  );
};

export default Loader;
